import React, { useState, useEffect } from "react";
import { CustomInput, Input, Table } from "reactstrap";
import { NumberFormatInput } from "../../NumberFormatInput/NumberFormatInput";
import * as OrderItemUI from "../../Order/Item";
import classnames from "classnames";
import style from "./Cross.module.scss";
import { Field } from "../Order/Field/Field";
import { FormattedNumber } from "../../FormattedNumber/FormattedNumber";

const ItemRow = ({
  order,
  id,
  actions,
  title = "",
  maxDecimals = 4,
  loading,
  fees = { Fees: null },
  ...props
}) => {
  const [showQuantity, setShowQuantity] = useState(false);
  const enabled = props.item && props.item.enabled;
  const readonly = props.item && props.item.readonly;
  const [showFees, setShowFees] = useState(false);
  const item = props.item || {};
  let timer = null;

  const toggleShowFees = () => {
    setShowFees((prev) => !prev);
  };

  // Show price by default
  const showPrice = props.showPrice === undefined || props.showPrice === true;

  useEffect(() => {
    // calculates whether or not to show the quantity fields
    if (!order || (order && order.AssetClassForm !== "Repo")) {
      setShowQuantity(true);
    }
  }, [order]);

  useEffect(() => {
    // calculates whether or not to show the quantity fields
    if (!order || (order && order.AssetClassForm !== "Repo")) {
      setShowQuantity(true);
    }
  }, [order]);

  const updateValues = (component, data) => {
    actions.change(id, component, data);
  };

  return (
    <React.Fragment>
      {title != "" ? <div>{title}</div> : null}
      <div className={`${style.item} ${enabled ? style.active : ""}`}>
        <div className={style.fields}>
          {item.loading || loading ? (
            <span className={`${style.loadingCbox} ${style.loading}`}></span>
          ) : (
            <CustomInput
              type="checkbox"
              id={`cbox-${id}`}
              checked={enabled || false}
              disabled={readonly}
              className={style.checkbox}
              onChange={(e) => actions.toggle(id)}
            />
          )}{" "}
          {showQuantity && (
            <React.Fragment>
              <Field label={"Quantity"} error={item["error_quantity"]}>
                <NumberFormatInput
                  type="text"
                  customInput={Input}
                  value={item.quantity === undefined ? "" : parseFloat(item.quantity)}
                  disabled={!enabled || readonly}
                  invalid={!!item["error_quantity"]}
                  onValueChange={(e) => updateValues("quantity", e.value)}
                  placeholder={"Quantity"}
                  dataTypeDecimalName="quantity"
                />
              </Field>
              {showPrice && (
                <React.Fragment>
                  <span className={style.arroba}>@</span>
                  <Field label={"Price"} error={item["error_price"]}>
                    <NumberFormatInput
                      type="text"
                      customInput={Input}
                      value={parseFloat(item.price) || ""}
                      invalid={!!item["error_price"]}
                      disabled={!enabled || props.priceDisabled || readonly}
                      onValueChange={(e) => updateValues("price", e.value)}
                      decimalScale={maxDecimals}
                      dataTypeDecimalName="price"
                      placeholder={"Price"}
                    />
                  </Field>
                </React.Fragment>
              )}
            </React.Fragment>
          )}
        </div>
        {order && <OrderDetail order={order} loading={item.loading} />}
        {fees.Fees && (
          <React.Fragment>
            <span
              className={`${style.showFeesLink} ${enabled ? style.active : ""}`}
              onClick={enabled ? toggleShowFees : null}
            >
              Show fees
            </span>
            {showFees && <Fees fees={fees.Fees} />}
          </React.Fragment>
        )}
        {props.children}
      </div>
    </React.Fragment>
  );
};

export const OrderDetail = ({ order, loading }) => {
  return (
    <div className={classnames(style.order, `cls-${order.AssetClassForm}`)}>
      <div>
        {order.OrderId && order.OrderId > 0 && (
          <React.Fragment>
            <b>#{order.OrderId}</b>{" "}
          </React.Fragment>
        )}
        {OrderItemUI.renderOrderSide(order)} {OrderItemUI.renderOrderQuantity(order)}{" "}
        {OrderItemUI.renderOrderQuantityType(order)} {OrderItemUI.renderOrderSymbol(order)}
        {" @ "}
        {OrderItemUI.renderOrderPrice(order)} {OrderItemUI.renderOrderTimeFrame(order)}{" "}
        <span>
          {order.OrderAdvisorName}/{order.OrderTraderName != "" ? order.OrderTraderName : "-"}
        </span>{" "}
        {OrderItemUI.renderOrderAccount(order)}{" "}
      </div>

      <hr className={style.line} />

      <div className={style.bottomRow}>
        <div style={{ display: "inline-block", verticalAlign: "middle" }}>
          {loading ? <span className={style.loading}></span> : OrderItemUI.renderOrderStatus(order)}{" "}
          {OrderItemUI.renderExecutionsAvg(order)}
        </div>
      </div>
    </div>
  );
};

const Fees = ({ fees }) => {
  return (
    <div className={style.feesContainer}>
      <Table className={style.feesTable} responsive>
        <tbody>
          {fees.map((feeItem, idx) => (
            <tr key={idx}>
              <td>
                {feeItem.Description}:{" "}
                <FormattedNumber value={feeItem.FeeAmount} dataTypeDecimalName="currency" />
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default ItemRow;
